import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const IMS = () => {
    const heading = `IMAGE MANAGEMENT SERVICE (IMS)`;
    const details = `Create and manage system images with ease.`;

    const overview = [
        `Image Management Service (IMS) is a powerful and important tool, especially for the users who prefer to use system images other than the predefined system images. You can create a system disk image or data disk image from a disk or an external image file. You can also create a full-ECS image from an ECS with data disks or a backup of an ECS.`
    ];

    const advantages = [
        [
            `Easier to Manage`,
            `IMS allows you to create Virtual Machines using publicly available image or to bring in your own private/external image file and deploy services in batches.`,
            icon
        ],
        [
            `Secure`,
            `Using a reinforced security system, IMS ensures that the images are stored securely and are available across every region.`,
            icon
        ],
        [
            `Trouble-free Imports`,
            `Private images can be easily imported and used for creating servers, simplifying service migration.`,
            icon
        ],
        [`Flexible`, `The images can be managed through the management console or the APIs.`, icon]
    ];

    const functions = [
        [
            `Image Creation and Management`,
            [
                `IMS enables you to create private images from a server or external image file. Private images can be easily modified and deleted, even be shared with other tenants.`
            ]
        ],
        [`Server Creation`, [`An image, either public or private, can be used to create servers in batches.`]],
        [
            `Operating Systems`,
            [`Popular Operating Systems are already included, such as Windows, Ubuntu, CentOS, and Debian.`]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default IMS;
